import Vue from 'vue';
import axios from 'axios';

export default {
  name: 'ProblemLog',
  props: ['dataObj'],
  data: function () {
    return {
      problemLogData: {
        complainTypeId: 0,
        elementId: 0,
        elementTypeId: 0,
        id: 0,
        isReadOnly: false,
        locationDescription: '',
        mActivityId: 27,
        problemAddress: '',
        problemFlat: '',
        problemHouse: '',
        serviceTypeId: 0,
        stationId: 0,
        townshipId: 0,
        workflowEmployeeId: 1
      },
      bPortalGis: false,
      element: {},
      stations: [],
      complainTypes: [],
      serviceTypes: [],
      townships: [],
      maintenanceActivities: [],
      workflowEmployees: [],
      elementTypes: [],
      message: '',
    }
  },
  computed: {
    problemLogId: function () {
      return this.problemLogData.id;
    },
  },
  watch: {
    problemLogId: function (value) {
      if (value > 0) {
        this.getStations();
        this.getComplainTypes();
        this.getServiceTypes();
        this.getTownships();
        this.getWorkflowEmployees();
        this.getElementTypes();
        this.getProfileDetails();
        this.getWorkflowEmployees();
        this.getElement();
        this.getMaintenanceActivities();
        this.$forceUpdate();
      }
    },
  },
  created() {
    this.init();
    this.$root.$on('problemLog_updated', this.init);
  },
  methods: {
    init() {
      Vue.nextTick(() => {
        this.problemLogData = this.dataObj;
      });
    },
    getServiceTypes() {
      axios.post('/Om/GetServiceTypes')
        .then(response => {
          if (response.data.data.status == 0) {
            this.serviceTypes = response.data.items;
          }
          else {
            this.$alertMsg(response.data.data.text)
          }
        })
        .catch(e => {
          console.log('getServiceTypes');
          console.log(e);
          this.$router.push('/login');
          return false;
        })
    },
    getStations() {
      axios.post('/Om/GetStations')
        .then(response => {
          if (response.data.data.status == 0) {
            this.stations = response.data.items;
          }
          else {
            this.$alertMsg(response.data.data.text)
          }
        })
        .catch(e => {
          console.log('getStations');
          console.log(e);
          this.$router.push('/login');
          return false;
        })
    },
    getMaintenanceActivities() {
      this.$store.state.notifier.asyncBlock(
        axios.post('/Om/GetMaintenanceActivities', { Value: this.problemLogData.complainTypeId }),
        response => {
          if (response.status === 200 && response.data.data.status === 0) {
            this.maintenanceActivities = response.data.items;
          }
          else {
            this.$alertMsg(response.data.data.text);
          }
        },
        err => {
          console.log('getMaintenanceActivities');
          console.log(err);
          this.$alertMsg(err.response.data);
          this.$router.push('/login');
        },
        'Loading Details'
      );
    },
    getElement() {
      axios.post('/Om/GetElement', { TypeId: this.problemLogData.elementTypeId, Id: this.problemLogData.elementId })
        .then(response => {
          if (response.data.data.status == 0) {
            this.element = response.data.item;
          }
          else {
            this.$alertMsg(response.data.data.text)
          }
        })
        .catch(e => {
          console.log('getElement');
          console.log(e);
          this.$router.push('/login');
          return false;
        })
    },
    getGisLayerName() {
      var res = this.elementTypes.filter(t => t.typeId == this.problemLogData.elementTypeId);
      return (res.length == 1) ? res[0].gisLayerName : "";
    },
    getElementTypes() {
      this.elementTypes = this.$store.state.elementTypesPlain;
      /*axios.get('/Element/GetElementTypesPlain')
        .then(response => {
          if (response.status == 200) {
            this.elementTypes = response.data.items;
          }
          else {
            this.$alertMsg(response.data)
          }
        })
        .catch(e => {
          console.log('getElementTypes');
          console.log(e);
          this.$router.push('/login');
          return false;
        })*/
    },
    getComplainTypes() {
      axios.post('/Om/GetComplainTypes')
        .then(response => {
          if (response.data.data.status == 0) {
            this.complainTypes = response.data.items;
          }
          else {
            this.$alertMsg(response.data.data.text)
          }
        })
        .catch(e => {
          console.log('getComplainTypes');
          console.log(e);
          this.$router.push('/login');
          return false;
        })
    },
    getTownships() {
      axios.post('/Om/GetTownships')
        .then(response => {
          if (response.data.data.status == 0) {
            this.townships = response.data.items;
          }
          else {
            this.$alertMsg(response.data.data.text)
          }
        })
        .catch(e => {
          console.log('getTownships');
          console.log(e);
          this.$router.push('/login');
          return false;
        })
    },
    getWorkflowEmployees() {
      axios.post('/Om/GetWorkflowEmployees', { Value: -1 })
        .then(response => {
          if (response.data.data.status == 0) {
            this.workflowEmployees = response.data.items;
          }
          else {
            this.$alertMsg(response.data.data.text)
          }
        })
        .catch(e => {
          console.log('getWorkflowEmployees');
          console.log(e);
          this.$router.push('/login');
          return false;
        })
    },
    save() {
      axios.post('/Om/UpdateProblemLogDetails',
        {
          Id: this.problemLogData.id,
          ComplainTypeId: this.problemLogData.complainTypeId,
          ServiceTypeId: this.problemLogData.serviceTypeId,
          LocationDescription: this.problemLogData.locationDescription,
          TownshipId: this.problemLogData.townshipId,
          ProblemAddress: this.problemLogData.problemAddress,
          ProblemHouse: this.problemLogData.problemHouse,
          ProblemFlat: this.problemLogData.problemFlat,
          StationId: this.problemLogData.stationId
        })
        .then(response => {
          if (response.data.data.status == 0) {
            this.$alertMsg(this.$t('messages.JobcardSavedSuccess'), 2);
          }
          else
            this.$alertMsg(response.data.data.text)
        })
        .catch((e) => {
          console.log('save');
          console.log(e);
          this.$alertMsg(e.message)
        })
    },
    completeProblemLog() {
      axios.post('/Om/UpdateProblemLogDetails',
        {
          Id: this.problemLogData.id,
          ComplainTypeId: this.problemLogData.complainTypeId,
          ServiceTypeId: this.problemLogData.serviceTypeId,
          LocationDescription: this.problemLogData.locationDescription,
          TownshipId: this.problemLogData.townshipId,
          ProblemAddress: this.problemLogData.problemAddress,
          ProblemHouse: this.problemLogData.problemHouse,
          ProblemFlat: this.problemLogData.problemFlat,
          StationId: this.problemLogData.stationId
        })
        .then(response => {
          if (response.data.data.status == 0) {
            axios.post('/Om/IssueJobcard',
              {
                Type: 2,
                ObjectsId: this.problemLogData.id,
                WorkflowEmployeeId: this.problemLogData.workflowEmployeeId
              })
              .then(response => {
                if (response.data.data.status == 0) {
                  this.$alertMsg(this.$t('messages.JobcardIssuedProblemLogCompleted'), 2);
                  this.problemLogData.isReadOnly = true;
                }
                else
                  this.$alertMsg(response.data.data.text)
              })
              .catch((e) => { this.$alertMsg(e.message) })
          }
          else
            this.$alertMsg(response.data.data.text)
        })
        .catch((e) => {
          console.log('completeProblemLog');
          console.log(e);
          this.$alertMsg(e.message)
        })
    },
    close() {
      this.$router.replace("/omApplications");
    },
    getProfileDetails() {
      axios.post('/account/GetProfileDetails')
        .then(response => {
          //add flag for field worker user
          //this.user['isFieldWorker'] = response.data.item.isFieldWorker;

          if (response.data.data.status == 0)
            this.bPortalGis = (response.data.item.portalGis && response.data.item.portalGis == true) ? true : false;
        })
        .catch(e => {
          console.log('getProfileDetails');
          console.log(e);
          this.$parent.user.authenticated = false;
          this.$router.push('/login');
        })
    },
    zoomToElement() {
      axios.post('/GIS/GetZoomToElementUrl', { ElementType: this.element.typeId, ElementId: this.element.id })
        .then(response => {
          if (response.data.data.status == 0) {
            var url = response.data.url;
            window.open(url, '_blank');
          }
          else {
            this.$alertMsg(response.data.data.text)
          }
        })
        .catch(e => {
          console.log('zoomToElement');
          console.log(e);
          this.$router.push('/login');
          return false;
        })
    },
    //zoomToElement() {
    //  var route = this.$router.resolve({ name: 'gis', params: { command: 'zoomToElement', param: { type: this.element.typeId, id: this.element.id, clearAll: true } } });
    //  window.open(route.href, '_blank');
    //},
  }

}
